import Icon from "@3gaam/shared/components/general/icon";
import { Link } from "react-router-dom";

type Item = {
  path: string;
  exact?: boolean;
  label?: string;
  icon?: string;
  className?: string;
};

type Props = {
  item: Item;
};

const DrawerItem = ({ item }: Props) => {
  return (
    <Link
      to={item.path}
      className="d-flex align-items-center dropdown-item px-4 py-3"
    >
      <span className="d-inline-flex font-16 ml-3 text-gray3">
        {item.icon && <Icon name={item.icon} className={item.className} />}
      </span>
      {item?.label}
    </Link>
  );
};

export default DrawerItem;
